import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { phases } from '../data/content';
export function SystemPhases() {
  return <section aria-labelledby="sistema-title" className="w-full bg-plum-700 px-5 py-20 sm:py-24" data-id="element-137" data-mp="125z7y16p5cgp">
      <div className="mx-auto max-w-content" data-id="element-138" data-mp="177y9d5ivlzb0">
        <div className="text-center sm:text-left" data-id="element-139" data-mp="1c5q0vyflzjeo">
          <p className="inline-flex items-center gap-2 rounded-full border border-rose-300/40 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-rose-200" data-id="element-140" data-mp="1c57yek2cs8yb">
            <SparklesIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-141" data-mp="jgauxn2swgpm" />
            Sistema Después de Él
          </p>
          <h2 id="sistema-title" className="mt-6 max-w-3xl font-display text-4xl font-semibold leading-tight tracking-tight text-cream-50 sm:text-5xl lg:text-6xl" data-id="element-142" data-mp="ofdnw95iawh8">
            El método integral para mujeres en relaciones tóxicas
          </h2>
          <p className="mt-5 text-lg text-rose-100" data-id="element-143" data-mp="pt1the23j3q">Un sistema que trabaja en tres fases:</p>
        </div>

        <ol className="mt-12 grid gap-10 sm:grid-cols-3" data-id="element-144" data-mp="29p23i0qroaxh">
          {phases.map(phase => <li key={phase.label} className="flex h-full flex-col border-t border-rose-300/40 pt-5" data-id="element-145" data-mp="24s1vvle9r049">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-rose-300" data-id="element-146" data-mp="1zz8sb0ujdxtr">
                {phase.label}
              </p>
              <h3 className="mt-3 font-display text-3xl font-semibold text-cream-50" data-id="element-147" data-mp="1vwm5xfgmx53y">
                {phase.name}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-cream-200/85" data-id="element-148" data-mp="1lzznexbs6q53">{phase.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}